import { useContext } from 'react';
import ErrorHandlingContext from '../contexts/ErrorHandlingContext';
export const useErrorHandling = (context = ErrorHandlingContext) => useContext(context);
export default useErrorHandling;
